export {
  default as addressBarSizeSlice,
  setAddressBarSize,
} from './address-bar-size.slice';
